module.exports = __webpack_public_path__ + "img/bottom-shadow.5eaf711b.png";